import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { _AssetItemHistory } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { _DocumentFactory, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { DocumentViewer } from "../../../../../../theme/Component/DocumentViewer";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { BasicSwitch } from "../../../../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";

interface Props {
    idItem: number;
}

export const AssetItemHistory = ({ idItem }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AssetItemHistory);
    const paginador = usePaginator();

    const [show, setShow] = useState<boolean>(false);

    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [verdocregistro, setModalverdocregistro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });


    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);

    useEffect(() => {
        getLista();
    }, [idItem, paginador.page])

    const getLista = () => {

        instance.getFixedAssetItemHistory(idItem, show, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15);
                setLista(resp.List)
            }
        ).catch(err => { toast.error(err) })

    }

    const listaBotones = () => {
        const botones = [

            { titulo: 'Ver Documento', icono: 'ri-tablet-line', visible: _single.canDelete(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const verDocumentos = () => {

        if (bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(bean.IDDocument, null, bean.InitDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdocregistro({ ...verdocregistro, "view": true });
                }
            ).catch(err => { toast.error(err) })
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const head = [
        { title: 'ID', property: 'IDHistory', visible: true },
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Numero Documento', property: 'Consecutive', visible: true },
        { title: 'Cuentas de Orden', property: 'OrderAccountant', visible: true },
        { title: 'Controlado', property: 'Checked', visible: true },
        { title: 'Línea/Grupo', property: 'FixedAssetLineName', visible: true },
        { title: 'Clase', property: 'BrandStr', visible: true },
        // { title: 'Placa', property: 'TicketCode', visible: true },
    ]




    return (

        <div className="row">
            <div className="col-md-6">
                <BasicSwitch label="Mostrar Documentos Anulados" estado={show} eventChange={(e) => { setShow(e) }} />
            </div>
            <div className="col-md-6">
                <BasicButton eventClick={()=>{getLista()}} icon="ri-search-line" children={"Buscar"} />
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} records={paginador}></BasicTable>
            </div>
            <div className="col-md-12">
                <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docs}
                                IDDocument={bean.IDDocument}
                                Since={bean.InitDate}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>

    )
}